import { bool, number, node, object, func, arrayOf, string, oneOfType } from "prop-types";
import { observer } from "mobx-react";
import { SortableList } from "@components";

export const TimelineSectionsRowGroupList = observer(({
  disabled,
  listElements,
  onReorder,
  children,
  group,
}) => (
  <SortableList
    list={listElements}
    path={group}
    group={group}
    onListReorder={onReorder}
    displayAsColumnFlexbox
    disabled={disabled}
  >
    { children }
  </SortableList>
));

TimelineSectionsRowGroupList.propTypes = {
  listElements: arrayOf(object),
  onReorder: func,

  group: arrayOf(oneOfType([number, string])),
  children: node,
  disabled: bool,
};
